import Vue from 'vue'
import Vuex from 'vuex'
import riderConfirmCode from '@/pages/rider-confirm-code/store/index.js'
import common from '@/store/common'
import advertise from '@/pages/advertise/store/index.js'
import itemBrStore from '@/pages/dishes-for-br/store/item-v4'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    ...riderConfirmCode.state,
    ...common.state,
    ...itemBrStore.state,
  },
  getters: {
    ...riderConfirmCode.getters,
    ...common.getters,
    ...itemBrStore.getters,
  },
  mutations: {
    ...riderConfirmCode.mutations,
    ...common.mutations,
    ...itemBrStore.mutations,
  },
  actions: {
    ...riderConfirmCode.actions,
    ...common.actions,
    ...itemBrStore.actions,
  },
  modules: {
    riderConfirmCode,
    common,
    advertise,
    itemBrStore,
  },
})
